import { render, staticRenderFns } from "./CatalogVehicleFile.vue?vue&type=template&id=9edfb4e4&"
import script from "./CatalogVehicleFile.vue?vue&type=script&lang=js&"
export * from "./CatalogVehicleFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports